import { CheckCircle, Loader } from 'lucide-react';
import type { PaymentBanner } from '@/hooks/usePaymentConfirmationPolling';

const STYLES = {
    processing: 'border-blue-200 bg-blue-50 text-blue-800',
    confirmed: 'border-green-200 bg-green-50 text-green-800',
    timeout: 'border-yellow-200 bg-yellow-50 text-yellow-800',
} as const;

export function PaymentConfirmationBanner({ banner }: { banner: PaymentBanner }) {
    if (!banner) return null;
    return (
        <div className={`mb-4 rounded-md border p-3 text-sm ${STYLES[banner.status]}`}>
            <div className="flex items-center gap-2">
                {banner.status === 'processing' ? <Loader className="h-5 w-5 animate-spin" /> : <CheckCircle className="h-5 w-5" />}
                <span>{banner.message}</span>
            </div>
        </div>
    );
}
